import React from 'react'

const Improve = () => {
  return (
    <div>Improve</div>
  )
}

export default Improve